var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.htmlTag,
    _vm._g(
      {
        tag: "component",
        class: [_vm.buttonClass, _vm.customClasses],
        attrs: { disabled: _vm.disabled, "aria-label": _vm.label }
      },
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.size } })
        : _c(
            "span",
            { staticClass: "button__content" },
            [
              _vm._t("default", function() {
                return [_vm._v(_vm._s(_vm.label))]
              }),
              _vm.arrowLink
                ? _c(
                    "span",
                    [
                      _c("icon", {
                        attrs: { name: "arrow-right", size: "11px" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }